import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import * as styleUtils from '../../../utils/styleUtils';

import * as buttonConstants from './buttonConstants';
import {I18nMessage} from '../../contexts/I18n';

import styles from './Button.scss';


function Button({children, cssClass, flavor, iconEnd, iconStart, isDisabled, labelI18n, onClick}) {

    const className = styleUtils.toClasses(
        styles.button,
        styles[flavor],
        cssClass,
        iconStart && styles.iconStart,
        iconEnd && styles.iconEnd
    );

    const {formatMessage} = useIntl();

    const additionalProps = {};
    if (labelI18n) {
        additionalProps['aria-label'] = formatMessage({id: labelI18n});
    }

    return (
        <button
            {...additionalProps}
            className={className}
            disabled={isDisabled}
            onClick={event => {

                event.preventDefault();
                event.stopPropagation();

                if (!isDisabled) {
                    onClick();
                }
            }}
            type={'button'}
        >
            {iconStart}
            <span>{labelI18n && (<I18nMessage id={labelI18n}/>)}</span>
            {iconEnd}
            {children}
        </button>
    );
}


Button.propTypes = {
    children: PropTypes.any,
    cssClass: PropTypes.string,
    flavor: PropTypes.oneOf(buttonConstants.FLAVORS),
    iconEnd: PropTypes.element,
    iconStart: PropTypes.element,
    isDisabled: PropTypes.bool,
    labelI18n: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

Button.defaultProps = {
    cssClass: '',
    flavor: buttonConstants.FLAVOR_DEFAULT,
    isDisabled: false
};


export default Button;
